import { createContext, useContext } from 'react';

const CashStatusContext = createContext();

export const useCashStatus = () => useContext(CashStatusContext);

export default CashStatusContext;